import React from 'react';
import { connect } from 'react-redux';
import { IconButton, ListItem, Box, ListItemText } from '@mui/material';
import { createActions } from '../../../../store';
import { RotateRightRounded } from '@mui/icons-material';

const BackdropReflectionDirectionListItem = (props) => {
    const { direction, type, updateBackgroundSettings } = props;

    const onRotateClick = () => {
        var newDirection = direction + 1;
        if (newDirection > 3)
            newDirection = 0;

        updateBackgroundSettings({
            reflection: {
                type: type,
                direction: newDirection
            }
        });
    };

    return (
        <ListItem onClick={onRotateClick}>
            <ListItemText>
                Rotate Reflection
            </ListItemText>
            <Box>
                <IconButton
                    onClick={onRotateClick}
                    size='small'
                >
                    <RotateRightRounded />
                </IconButton>
            </Box>
        </ListItem>
    );
};

const mapStateToProps = (state) => {
    const { direction, type } = state.createPreview.present.videoSettings.background.reflection;
    return { direction, type }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropReflectionDirectionListItem);